export class GambleActions {
    static ActionGambleStart: string = "GAMBLE_START";
    static ActionGambleRed: string = "GAMBLE_RED";
    static ActionGambleBlack: string = "GAMBLE_BLACK";
    static ActionGambleHalve: string = "GAMBLE_HALVE";
    static ActionGambleCollect: string = "GAMBLE_COLLECT";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/GambleActions.ts
 **/